import React, { useState, useEffect } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Card,
  Form,
  Input,
  Grid,
  Button,
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  ChipInput,
  Col,
  SuccessModal,
  Span
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import { EmailGroup } from 'services/NGT/Parameterization'
import { SPACING, COLORS, FONTS, TYPOGRAPHY } from 'utils'
import * as yup from 'yup'
import { useModal } from 'hooks'

const schema = yup.object({
  descricaoGrupos: yup.string().required('Campo obrigatório'),
  emailsGrupo: yup.array().min(1, 'Informe pelo menos um E-mail'),
  nomeGrupo: yup.string().required('Campo obrigatório')
})
export interface GrupoEmail {
  grupoDeEmailItemId: number
  grupoEmailId: number
  email: string
}
const GroupEmail: React.FC = () => {
  const {
    reset,
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isSuccess, toggleSucessModal] = useToggle()
  const [isError, toggleErrorModal] = useToggle()
  const [openModal, setOpenModal] = useToggle()
  const [idDelete, setIdDelete] = useState<number>()
  const { setLoading, setMsgErro } = useLoading()
  const [Message, setMessage] = useState('')
  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [tableData, setTableData] = useState([])
  const [boolEditar, setBoolEditar] = useState(false)
  const [idEdit, setIdEdit] = useState()
  const [idGrupoEmail, setIdGrupoEmail] = useState()
  const handleChangePage = (newPage: number) => setPage(newPage)

  const { showModal } = useModal()

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleDelete = (id: number) => {
    setLoading('loading')

    EmailGroup()
      .DeleteGrupoEmail(id)
      .then(() => {
        setMessage('Deletado com Sucesso')
        toggleSucessModal()
        getAll()
        setLoading('idle')
        setOpenModal()
        setBoolEditar(false)
      })
      .catch((error) => {
        // setMessage('erro ao deletar')
        // toggleErrorModal()
        // setMsgErro('Não foi possível deletar o e-mail')
        setLoading('idle')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível deletar o e-mail',
          type: 'error'
        })
        setBoolEditar(false)
        // setOpenModal()
      })
  }

  const handleEdit = (editItem) => {
    const grupoEmails = editItem.tGrupoDeEmailItems?.map((email) => {
      return email.email
    })
    setBoolEditar(true)
    setValue('nomeGrupo', editItem.nome)
    setValue('descricaoGrupos', editItem.descricao)
    setValue('emailsGrupo', grupoEmails || null)
    setIdEdit(editItem.grupoEmailId)
    setIdGrupoEmail(editItem.grupoEmailId)
  }

  const handleSubmitForm = (form) => {
    setLoading('loading')
    const object = {
      ativo: true,
      descricao: form.descricaoGrupos,
      nome: form.nomeGrupo
    }
    if (!boolEditar) {
      const grupoDeEmailItem = form.emailsGrupo.map((email) => {
        return { email: email }
      })
      object['grupoDeEmailItem'] = grupoDeEmailItem
      EmailGroup()
        .create(object)
        .then(() => {
          setMessage('Adicionado com sucesso')
          toggleSucessModal()
          getAll()
          resetForm()
          setLoading('idle')
        })
        .catch((error) => {
          // setMessage('não foi possível adicionar')
          // toggleErrorModal()
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Não foi possível adicionar!',
            type: 'error'
          })
          resetForm()

          // setMsgErro('Não foi possível realizar o cadastro')
        })
    } else {
      object['grupoEmailId'] = idEdit
      const grupoDeEmailItem = form.emailsGrupo.map((email) => {
        return {
          email: email,
          grupoEmailId: idGrupoEmail
        }
      })
      object['grupoDeEmailItem'] = grupoDeEmailItem
      EmailGroup()
        .update(object)
        .then(() => {
          setMessage('Alterado com sucesso')
          toggleSucessModal()
          getAll()
          resetForm()
          setLoading('idle')
          setBoolEditar(false)
        })
        .catch((error) => {
          // setMessage('não foi possível alterar')
          // toggleErrorModal()
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Não foi possível alterar!',
            type: 'error'
          })
          setBoolEditar(false)
          resetForm()

          // setMsgErro('Não foi possível realizar o cadastro')
        })
    }
  }

  const resetForm = () => {
    const defaultValues = {
      descricaoGrupos: '',
      emailsGrupo: [],
      nomeGrupo: ''
    }
    reset(defaultValues)
  }
  const getAll = () => {
    setLoading('loading')
    EmailGroup()
      .getAll()
      .then((response) => {
        setTableData(response.data)
        setLoading('idle')
      })
      .catch((error) => {
        // setMsgErro('Não foi possível obter os e-mails')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível obter os e-mails',
          type: 'error'
        })
      })
  }

  useEffect(() => {
    getAll()
  }, [])
  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Form
          onSubmit={handleSubmit(handleSubmitForm)}
          marginLeft={SPACING.spacing20}
          marginRight={SPACING.spacing20}
          marginBottom={SPACING.spacing10}
          padding={SPACING.spacing20}
        >
          <Grid
            gridCols="2fr 5fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Nome do Grupo"
              placeholder="Nome do grupo"
              formValue="nomeGrupo"
              maxLength={300}
              type="alfanumeric"
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Descrição do Grupo"
              placeholder="Descrição do grupo"
              formValue="descricaoGrupos"
              maxLength={300}
              type="alfanumeric"
              required
            />
          </Grid>
          <Grid
            gridCols="1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <ChipInput
              control={control}
              mensagem="Pressione espaço para selecionar um E-mail"
              errors={errors}
              placeholder=""
              formValue="emailsGrupo"
              only="email"
              label="E-mails Grupo"
              maxLength={50}
              setValue={setValue}
              enableInsertOnEnter
            />
          </Grid>
          <div style={{ height: SPACING.spacing20 }}></div>
          <Row justifyContent="flex-end">
            <Button
              onClick={() => resetForm()}
              variantButton="text"
              text="LIMPAR"
            />
            <div style={{ width: SPACING.spacing20 }}></div>
            {!boolEditar && <Button type="submit" text="SALVAR" />}
            {boolEditar && (
              <>
                <Button
                  onClick={() => {
                    resetForm()
                    setBoolEditar(false)
                  }}
                  variantButton="text"
                  text="voltar"
                />
                <div style={{ width: SPACING.spacing20 }}></div>
                <Button type="submit" text="Alterar" />
              </>
            )}
          </Row>
        </Form>
        <TableContainerStyled>
          <TableStyled>
            <TableHeadStyled>
              <TableRowStyled>
                <TableCellStyled minwidth="20px" align="left">
                  Nome do Grupo
                </TableCellStyled>
                <TableCellStyled minwidth="20px" align="left">
                  Descrição do Grupo
                </TableCellStyled>
                <TableCellStyled minwidth="20px" align="left">
                  E-mail Grupo
                </TableCellStyled>
                <TableCellStyled minwidth="50px" align="left">
                  Ações
                </TableCellStyled>
              </TableRowStyled>
            </TableHeadStyled>
            <TableBodyStyled>
              {(rowsPerPage > 0
                ? tableData?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : tableData
              )?.map((row) => (
                <TableRowStyled key={`${row.grupoEmailId}`}>
                  <TableCellStyled align="left">{row.nome}</TableCellStyled>
                  <TableCellStyled align="left">
                    {row.descricao}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Col>
                      {row.tGrupoDeEmailItems?.map((email) => {
                        return (
                          <Span
                            text={email.email}
                            key={email.grupoDeEmailItemId}
                          />
                        )
                      })}
                    </Col>
                  </TableCellStyled>
                  <TableCellStyled>
                    <Row alignItems="center">
                      <EditIcon onClick={() => handleEdit(row)} />
                      <DeleteIcon
                        onClick={() => {
                          setIdDelete(row.grupoEmailId)
                          setOpenModal()
                        }}
                      />
                    </Row>
                  </TableCellStyled>
                </TableRowStyled>
              ))}
            </TableBodyStyled>
          </TableStyled>
        </TableContainerStyled>
        <TableFooter
          page={page}
          rows={tableData}
          typeFooter="offline"
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Card>
      <SuccessModal
        message={Message}
        open={isSuccess}
        type="sucess"
        handleConfirm={toggleSucessModal}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={Message}
        open={isError}
        type="error"
        handleConfirm={toggleErrorModal}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={`Tem certeza de que deseja apagar o grupo e-mail?`}
        type="alert"
        handleCancel={() => setOpenModal()}
        handleConfirm={() => handleDelete(idDelete)}
        open={openModal}
      />
    </>
  )
}

export default GroupEmail
